var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleExclamation24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Filled/triangle-exclamation_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-Treatment-2-Copy",
    transform: "translate(-1339.000000, -290.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/triangle-exclamation_24px",
    transform: "translate(1339.000000, 290.749776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "triangle-exclamation",
    transform: "translate(4.000000, 5.000000)",
    fill: "#CD2026"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8213604,12.0316821 L9.15549605,0.656273569 C8.64516523,-0.218757856 7.35730648,-0.218757856 6.84353802,0.656273569 L0.180798744,12.0316821 C-0.332032173,12.9035884 0.306709516,14.0005028 1.33459018,14.0005028 L14.666319,14.0005028 C15.6901057,14.0005028 16.3307537,12.9067135 15.8213604,12.0316821 Z M7.24917759,4.25015264 C7.24917759,3.83607527 7.58512716,3.5001257 7.99920453,3.5001257 C8.4132819,3.5001257 8.74923146,3.83763782 8.74923146,4.25015264 L8.74923146,8.25029629 C8.74923146,8.66437366 8.4132819,9.00032323 8.02733054,9.00032323 C7.64137918,9.00032323 7.24917759,8.66593622 7.24917759,8.25029629 L7.24917759,4.25015264 Z M7.99920453,12.000431 C7.45668504,12.000431 7.01666924,11.5604152 7.01666924,11.0178957 C7.01666924,10.4753762 7.45637253,10.0353604 7.99920453,10.0353604 C8.54203652,10.0353604 8.98173981,10.4753762 8.98173981,11.0178957 C8.98048977,11.5597901 8.54297406,12.000431 7.99920453,12.000431 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation24Px);
export default __webpack_public_path__ + "static/media/triangle-exclamation_24px.9ec60bbc.svg";
export { ForwardRef as ReactComponent };